import i18n from '../../../../../../config/i18n';
import {
  formatNumberWithCurrency,
  getTaxTypes,
} from '../../../../../../helpers/invoiceHelpers';
import { getTaxTypePlaceholder, normalizeDecimalValue } from '../../helpers';

export const PAYMENTS_LINE_ITEMS_COLUMNS = ({ currency }) => [
  {
    key: 'invoiceNumber',
    field: 'invoiceNumber',
    label: 'createInvoice.e_invoice_number',
    required: true,
    type: 'text',
    headerTooltip: 'tooltips.prepaymentInvoiceNumber',
  },
  {
    key: 'invoiceIssueDate',
    field: 'invoiceIssueDate',
    label: 'createInvoice.prepaid_invoice_issue_date',
    headerTooltip: 'tooltips.prepaymentInvoiceIssueDate',
    required: true,
    type: 'datepicker',
  },
  {
    key: 'taxableAmount',
    field: 'taxableAmount',
    label: 'createInvoice.taxable_amount',
    headerTooltip: 'tooltips.taxableAmount',
    body: (lang, rowData) =>
      formatNumberWithCurrency(
        Number(rowData.taxableAmount).toFixed(3),
        currency,
        i18n.language,
      ),
    required: true,
    type: 'text',
  },
  {
    key: 'vatRate',
    field: 'vatRate',
    label: 'prepayment.vat_rate',
    headerTooltip: 'tooltips.prepaymentVatRate',
    body: (lang, rowData) =>
      getTaxTypes(lang).find((type) => type.value === rowData.vatRate)?.label ||
      rowData.vatRate,
    required: true,
    type: 'select',
  },
];

export const getPaymentFieldProps = (
  lang,
  t,
  setFieldValue,
  setFieldTouched,
) => ({
  invoiceNumber: {
    componentProps: {
      placeholder: t('createInvoice.add_invoice_number'),
      type: 'number',
      onChange: (e) => {
        setFieldValue(e.target.value);
        setFieldTouched?.(true, false);
      },
    },
  },
  invoiceIssueDate: {
    componentProps: {
      placeholder: t('createInvoice.select_date'),
      disabledDays: [{ after: new Date() }],
    },
  },
  taxableAmount: {
    componentProps: {
      placeholder: t('createInvoice.add_taxable_amount'),
      type: 'text',
      inputMode: 'decimal',
      maxlength: 15,
      onChange: (e) => {
        setFieldValue(normalizeDecimalValue(e.target.value));
      },
    },
  },
  vatRate: {
    componentProps: {
      options: getTaxTypes('', lang),
      onChange: (e) => {
        if (e === getTaxTypePlaceholder(lang)) {
          setFieldValue('');
        } else {
          setFieldValue(e);
        }
      },
    },
  },
});
